import { zAttrLabelsData } from "src/common/attributes/makeAttrLabel/types/ZAttrLabelsData";
import { z } from "zod";
import { zPermissionsList, ZPermissionsList } from "./Permission";
import { ZUid, zUid } from "./zUid";

export const zEntityValue = z.string().array().nullable();
export type ZEntityValue = z.infer<typeof zEntityValue>;

interface ZEntityFieldLazy {
  attributeId: ZUid;
  values: ZEntityValue;
  permissions?: ZPermissionsList | null;
  currencyEntity?: ZEntity | null;
}
export const zEntityField: z.ZodType<ZEntityFieldLazy> = z.lazy(() =>
  z.object({
    attributeId: zUid,
    values: zEntityValue,
    permissions: zPermissionsList.nullable().optional(),
    currencyEntity: zEntity.optional().nullable(), // используется только в FinancialInput и  FinancialView
  }),
);

export type ZEntityField = z.infer<typeof zEntityField>;

export const zEntity = z.object({
  id: zUid,
  objectId: zUid,
  attributeValues: zEntityField.array(),
  labelData: zAttrLabelsData.optional().nullable(),
  permissions: zPermissionsList.nullable().optional(),
  stateId: zUid.nullable().optional(),
  userId: zUid.nullable().optional(),
});

export type ZEntity = z.infer<typeof zEntity>;
